import React, {useEffect, useState} from 'react';
import {Form, Input, InputNumber, Modal, Radio, Select, Space, Tag, Typography} from "antd";
import {FIELDS_SCHEME, GENERAL_SCHEME} from "../../schemas";
import {fetchUsers} from "../../actions/users";

const AddCompanyMemberModal = ({ visible, onClose, onSubmit }) => {
  const [users, setUsers] = useState([]);

  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) fetchUsers().then(result => {
      setUsers(result.filter(user => !user.is_corporate));
    })
  }, [visible]);

  const handleSubmit = () => {
    form.validateFields()
      .then(values => {
        const { isNewUser, ...formData } = values;
        onSubmit(formData);
        form.resetFields();
        onClose();
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      title="Add New Member"
      open={visible}
      onOk={handleSubmit}
      onCancel={onClose}
      okText="Add Member"
      cancelText="Cancel"
      destroyOnClose
    >
      <Form size="large" variant="filled" initialValues={{ position: 'member', isNewUser: 'new' }} form={form} preserve={false} layout="vertical">
        <Form.Item
          name="isNewUser"
          label="Do you want to create a new user or add an existing one?"
          rules={GENERAL_SCHEME.required}
        >
          <Radio.Group>
            <Radio value="new">Create New User</Radio>
            <Radio value="existing">Add Existing User</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          shouldUpdate={(prevValues, curValues) => prevValues.isNewUser !== curValues.isNewUser}
          noStyle
        >
          {({ getFieldValue }) =>
            getFieldValue('isNewUser') === 'new' ? (
              <>
                <Form.Item
                  name="first_name"
                  label="First Name"
                  rules={GENERAL_SCHEME.required}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="last_name"
                  label="Last Name"
                  rules={GENERAL_SCHEME.required}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="email_address"
                  label="Email"
                  rules={[...GENERAL_SCHEME.required, ...FIELDS_SCHEME.email]}
                >
                  <Input />
                </Form.Item>
              </>
            ) : (
              <Form.Item
                name="user_id"
                label="Select Existing User"
                rules={GENERAL_SCHEME.required}
              >
                <Select
                  optionFilterProp="children"
                  placeholder="Select a user"
                  filterOption={(input, option) =>
                    option.children.props.children[1].props.children.join().toLowerCase().includes(input.toLowerCase())
                  }
                  showSearch
                >
                  {users.map(user => (
                    <Select.Option key={user.id} value={user.id}>
                      <Space>
                        {user.is_corporate ? (
                          <Tag style={{ width: 30, textAlign: 'center' }} bordered={false} color="volcano">C</Tag>
                        ) : (
                          <Tag style={{ width: 30, textAlign: 'center' }} bordered={false} color="blue">I</Tag>
                        )}
                        <Typography.Text>
                          {user.first_name} {user.last_name} ({user.email_address})
                        </Typography.Text>
                      </Space>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )
          }
        </Form.Item>
        <Form.Item
          name="position"
          label="Position"
          rules={GENERAL_SCHEME.required}
        >
          <Select placeholder="Select a position">
            <Select.Option value="director">Director</Select.Option>
            <Select.Option value="owner">Owner</Select.Option>
            <Select.Option value="member">Member</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          shouldUpdate={(prevValues, curValues) => prevValues.position !== curValues.position}
          noStyle
        >
          {({ getFieldValue }) =>
            getFieldValue('position') === 'owner' ? (
              <Form.Item
                name="percent"
                label="Ownership Percentage"
                rules={GENERAL_SCHEME.required}
                shouldUpdate={(prevValues, currentValues) => prevValues.position !== currentValues.position}
              >
                <InputNumber className="w100" min={0} max={100} formatter={value => `${value}%`} parser={value => value.replace('%', '')} />
              </Form.Item>
            ) : null
          }
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddCompanyMemberModal;
